module.exports = __webpack_public_path__ + "assets/img_pescatarian.png";


/*****************
 ** WEBPACK FOOTER
 ** ./assets/img_pescatarian.png
 ** module id = 129
 ** module chunks = 1
 **/